var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"test",staticStyle:{"width":"200px","height":"200px","background":"yellow"}},[_vm._v(" testtttttt ")])}
var staticRenderFns = []

export { render, staticRenderFns }